import { SUB_DOMAIN } from './domain';
import { DONATION_ROUTES, ROUTES } from './routes';

//* 연말 이벤트 한정 분기 — 되돌리는 절차는 src/plans/WEL-5478-donation-home-entry.md
//* 대상 목록이 아니라 제외 목록인 이유: dev·로컬 호스트는 서브도메인이 `www.dev`·null로 잡혀 대상 목록에 안 걸린다.
const ROOT_REWRITE_EXCLUDED_SUB_DOMAINS: readonly string[] = [
  SUB_DOMAIN.KB_PAY,
];
const DEFAULT_DONATION_HOME_SUB_DOMAINS: readonly string[] = [
  SUB_DOMAIN.TOSS,
  SUB_DOMAIN.KB_PAY,
  SUB_DOMAIN.KAKAOBANK,
];

export const shouldRewriteRootToDonation = ({
  subDomain,
  pathname,
  method,
}: {
  subDomain: string | null;
  pathname: string;
  method: string;
}) =>
  pathname === ROUTES.HOME.pathname &&
  (method === 'GET' || method === 'HEAD') &&
  !(subDomain && ROOT_REWRITE_EXCLUDED_SUB_DOMAINS.includes(subDomain));

export const hasGoodsDonationHome = (subDomain: SUB_DOMAIN | null) =>
  !(subDomain && DEFAULT_DONATION_HOME_SUB_DOMAINS.includes(subDomain));

const GOODS_HOME_IMAGE_BASE_URL = 'https://cdn.welfarehello.com/static';

export const GOODS_HOME_IMAGE_URL = {
  HERO: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-hero.png`,
  HERO_MOBILE: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-hero-m.png`,
  ZIP: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-zip.png`,
  ZIP_MOBILE: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-zip-m.png`,
  LOCKUP_WELLO: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-guide-logo-welo.png`,
  LOCKUP_KAKAO_FRIENDS: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-guide-logo-kako.png`,
  BOOK: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-book.png`,
  BOOK_SOLD_OUT: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-book-soldout.png`,
  PARTNERS: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-partners.png`,
  FRIEND: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-friend.png`,
  FRIEND_FRIEND_REWARD: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-friend-2.png`,
  FRIEND_ME_REWARD: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-friend-3.png`,
  FRIEND_EFFECT: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-friend-effect.png`,
  DESK_BOOK: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-desk-book.png`,
  EVENT_BANNER: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-event-banner.png`,
  HOMETOWN_EVENT_BANNER: `${GOODS_HOME_IMAGE_BASE_URL}/goods-event-banner-desktop.png`,
  HOMETOWN_EVENT_BANNER_MOBILE: `${GOODS_HOME_IMAGE_BASE_URL}/goods-event-banner-mobile.png`,
  GUIDE_OG: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-guide-og.png`,
  GUIDE_SHARE: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-guide-og-kakao-share.png`,
  KAKAO_BADGE: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-kakao-badge.png`,
  BOOK_OPEN: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-book-open.png`,
  BOOK_OPEN_WIDE: `${GOODS_HOME_IMAGE_BASE_URL}/goods-home-book-open-wide.png`,
} as const;

export const GOODS_EVENT_LANDING_HREF = DONATION_ROUTES.GUIDE.pathname;
